import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import "./vee-validate";
import numeral from "numeral";
// const SweetalertoOptions = {
//   confirmButtonColor: "#41b882",
//   cancelButtonColor: "#ff7674",
// };
import "sweetalert2/dist/sweetalert2.min.css";
import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueSweetalert2);

// vee-validate
import { ValidationProvider, ValidationObserver } from "vee-validate";
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

Vue.config.productionTip = false;

import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

Vue.filter("decimalFormat", function(value) {
  return numeral(value).format("0,0.00");
});

Vue.filter("numberFormat", function(value) {
  return numeral(value).format("0,0");
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
